export default function() {

  function formatelp(n) {
    let h,m,s;
    if (!n || n < 0) { return "-"; }
    s = Math.trunc(n);
    m = Math.trunc(n/60);
    s -= (60*m);
    h = Math.trunc(m/60);
    m -= (60*h);
    if (s < 10) s = "0"+s;
    if (m < 10) m = "0"+m;
    if (h == 0) {
      return ""+m+":"+s;
    }
    return ""+h+":"+m+":"+s;
  }

  function progressbar(player) {
    let pb = this;
    pb.player = player;
    pb.base = 0;
    pb.at = 0;
    pb.down = 0;
    pb.max = 0;
    pb.margin = 0;
    pb.mode = "seek";
    /* Playable range */
    pb.prange = null;
    /* Meta data segments */
    pb.segs = [];
    /* Selected clips for use in creating an edited video */
    pb.clips = [];
    pb.setseek = function(cb) {
      pb.seek = cb;
    }
    pb.sethov = function(cb) {
      pb.hov = cb;
    }
    pb.clientx2frac = function(clientx) {
      let rect = pb.cel.getBoundingClientRect();
      let frac = (clientx - rect.left)/rect.width;
      if (frac <= 0.01) return 0;
      if (frac >= 0.99) { return 1; }
      return frac;
    }
    pb.onclick = function(e) {
      let frac = pb.clientx2frac(e.clientX);
      if (!pb.mode || pb.mode == "seek") {
        /* Seek is a fraction of the DISPLAY time via progress bar. */
        let d_max = pb.vidtm2disp(pb.max);
        let d_at = frac * d_max;
        let at = pb.disp2vidtm(d_at);
        //console.log("Seek",d_at,at);
        pb.at = at;
        pb.seek && pb.seek(at,d_at);
        pb.update();
      } else {
        /* Editing clips only works with original contiguous videos */
        let at = frac * pb.max;
        if (pb.mode == "clip_select") {
          pb.mode = "clip_new";
          for (let c=0; c<pb.clips.length; ++c) {
            let clip = pb.clips[c];
            if (at >= clip.start && at <= clip.end) {
              pb.clip = clip;
              if (Math.abs(at-clip.start) < Math.abs(at-clip.end)) {
                pb.mode = "clip_start";
              } else {
                pb.mode = "clip_end";
              }
            }
          }
          if (pb.mode == "clip_new") {
            if (pb.clips.length < 3) {
              pb.clip = {};
              [pb.clip.start, pb.clip.start_i] =
                pb.player.snap_to(at);
              pb.clip.end = pb.clip.start;
              pb.clip.end_i = pb.clip.start_i;
              pb.clips.push(pb.clip);
              pb.clips = pb.clips.sort(function(a,b) {
                return a.start - b.start;
              });
              pb.seek(pb.clip.start,pb.clip.start);
              pb.mode = "clip_end";
            } else {
              pb.mode = "clip_select";
            }
          }
          for (let c=0; c<pb.clips.length; ++c) {
            let clip = pb.clips[c];
            if (c == 0) {
              clip.min = 0;
            } else {
              // Enforce 3s separation
              clip.min = pb.clips[c-1].end+3;
            }
            if (c == pb.clips.length-1) {
              clip.max = pb.max;
            } else {
              // Enforce 3s separation
              clip.max = pb.clips[c+1].start-3;
            }
          }
          pb.clip.start = Math.max(pb.clip.start, pb.clip.min);
          pb.clip.end = Math.min(pb.clip.end, pb.clip.max);
          if (pb.clip.min >= pb.clip.max) {
            /* The new clip cannot fit in the available space
             *  due to separation requirements */
            pb.clip.del = true;
            pb.clips = pb.clips.filter(function(clip) {
              if (clip.del) { return false; }
              return true;
            });
            pb.mode = "clip_select";
          }
          //console.log("clip_new",JSON.stringify(pb.clips));
        } else if (pb.mode == "clip_start" ||
                   pb.mode == "clip_end") {
          if (pb.clip && (pb.clip.end - pb.clip.start > 3) &&
              (pb.clip.start_i < pb.clip.end_i)) {
            // onmousemove already did the work
            if (pb.mode == "clip_start") {
              pb.seek(pb.clip.start,pb.clip.start);
            } else {
              pb.seek(pb.clip.end,pb.clip.end);
            }
          } else if (pb.clip) {
            /* start/end too close, delete */
            pb.clip.del = true;
            //console.log("clip_delete",JSON.stringify(pb.clip));
            pb.clips = pb.clips.filter(function(clip) {
              if (clip.del) { return false; }
              return true;
            });
          }
          delete pb.clip;
          pb.mode = "clip_select";
        }
      }
    }
    pb.onmousemove = function(e) {
      let frac = pb.clientx2frac(e.clientX);
      /* Like seek, this is a fraction of DISPLAY time via progress bar */
      let d_max = pb.vidtm2disp(pb.max);
      let d_at = frac * d_max;
      let at = pb.disp2vidtm(d_at);
      let seg_match;
      if (pb.segs) {
        for (let i=0; i<pb.segs.length; i++) {
          if (at > pb.segs[i].at &&
              (i == (pb.segs.length-1) || at < pb.segs[i+1].at)) {
            seg_match = pb.segs[i];
            break;
          }
        }
      }
      if (pb.mode == "clip_start") {
        if (pb.clip && at < pb.clip.end) {
          [pb.clip.start, pb.clip.start_i] =
            pb.player.snap_to(Math.max(at, pb.clip.min));
          pb.update();
        }
      } else if (pb.mode == "clip_end") {
        if (pb.clip && at > pb.clip.start) {
          [pb.clip.end, pb.clip.end_i] =
            pb.player.snap_to(Math.min(at, pb.clip.max),true);
          pb.update();
        }
      }
      let rect = pb.cel.getBoundingClientRect();
      pb.hov && pb.hov(frac, d_at, e.clientX,
                       rect.top, rect.right, seg_match);
    }
    pb.setcanvas = function(cel) {
      if (!cel) { return; }
      pb.cel = cel;
      cel.width = 1000+(2*pb.margin);
      cel.height = 21;
      cel.addEventListener('click', pb.onclick);
      cel.addEventListener('mousemove', pb.onmousemove, false);
      pb.ctx = cel.getContext("2d");
      pb.ctx.fillStyle = "#000050";
      pb.drawht = 9;
    }
    pb.set_segs = function(segs) {
      pb.segs = segs;
    }
    pb.set_prange = function(pr) {
      pb.prange = null;
      if (!pr || !pr.r) { return; }
      let off = 0;
      pb.prange = [];
      pr.r.forEach(function(r) {
        let x = {};
        x.v1 = r[0];
        x.v2 = r[1];
        x.p1 = off;
        off += (x.v2 - x.v1);
        x.p2 = off;
        pb.prange.push(x);
      });
      //console.log("range",off,JSON.stringify(pb.prange));
    }
    pb.vidtm2disp = function(tm) {
      if (!pb.prange || !pb.prange.length) { return tm; }
      if (tm < pb.prange[0].v1) {
        /* Return start */
        return pb.prange[0].p1;
      }
      for (let i=0; i<pb.prange.length; ++i) {
        let r = pb.prange[i];
        if (tm >= r.v1 && tm < r.v2) {
          return r.p1 + (tm - r.v1);
        }
      }
      /* Return end */
      return pb.prange[pb.prange.length-1].p2;
    }
    pb.disp2vidtm = function(tm) {
      if (!pb.prange || !pb.prange.length) { return tm; }
      if (tm < pb.prange[0].p1) {
        /* Return start */
        return pb.prange[0].v1;
      }
      for (let i=0; i<pb.prange.length; ++i) {
        let r = pb.prange[i];
        if (tm >= r.p1 && tm < r.p2) {
          return r.v1 + (tm - r.p1);
        }
      }
      /* Return end */
      return pb.prange[pb.prange.length-1].v2;
    }
    pb.draw_range = function(fill, ht, st, en, max) {
      let st_px = Math.trunc((1000*st)/max);
      let en_px = Math.trunc((1000*en)/max);
      let ht2 = (ht - 1) / 2;
      /* (21-1)/2 ==> 10 */
      pb.ctx.fillStyle = fill;
      pb.ctx.fillRect(st_px, (10-ht2), (en_px - st_px),  ht);
    }
    pb.draw_line = function(fill, wd, ht, at, max) {
      let at_px = Math.trunc((1000*at)/max);
      let ht2 = (ht - 1) / 2;
      let wd2 = (wd - 1) / 2;
      /* (21-1)/2 ==> 10 */
      pb.ctx.fillStyle = fill;
      pb.ctx.fillRect((at_px-wd2), (10-ht2), wd,  ht);
    }
    pb.draw_dot = function(fill, rad, at, max) {
      let at_px = Math.trunc((1000*at)/max);
      /* (21-1)/2 ==> 10 */
      pb.ctx.beginPath();
      pb.ctx.fillStyle = fill;
      pb.ctx.arc(at_px, 10, rad, 0, 2*Math.PI, false);
      pb.ctx.fill();
    }
    pb.update = function() {
      if (!pb.ctx) { console.warn("no ctx"); return; }
      let d_base = pb.vidtm2disp(pb.base);
      let d_at = pb.vidtm2disp(pb.at);
      let d_down = pb.vidtm2disp(pb.down);
      let d_max = pb.vidtm2disp(pb.max);
      //console.log("pb:"+d_at+","+d_down+","+d_max);
      if (d_max == 0 || d_max < d_at) {
        d_max = d_at+1;
      }
      if (d_down == 0 || d_down < d_at) {
        d_down = d_at;
      } else if (d_down > d_max) {
        d_down = d_max;
      }

      //console.log("pb:"+d_at+","+d_down+","+d_max);
      pb.ctx.clearRect(0,0,pb.cel.width,pb.cel.height);
      pb.draw_range("#505050", pb.drawht, 0,      d_base, d_max);
      pb.draw_range("#808000", pb.drawht, d_base, d_down, d_max);
      pb.draw_range("#505050", pb.drawht, d_down, d_max,  d_max);
      pb.draw_line ("#ffffff", pb.drawht, pb.drawht+2, d_at, d_max);

      if (pb.segs) {
        pb.segs.forEach(function(seg) {
          if (!seg.start) { return; }
          d_at = pb.vidtm2disp(seg.at);
          pb.draw_dot("#ffffff", pb.drawht, d_at, d_max);
        });
      }
      if (!pb.prange && pb.clips) {
        pb.clips.forEach(function(clip) {
          if (clip.end <= clip.start) { return; }
          let color = "rgba(100,100,250,0.4)";
          if (pb.clip && pb.clip.start == clip.start) {
            if ((pb.clip.end - pb.clip.start) < 3) {
              color = "rgba(200,40,40,1)"
            } else {
              color = "rgba(100,200,250,0.4)"
            }
          }
          pb.draw_range(color, 19, clip.start, clip.end, d_max);
        });
      }
    }
    pb.destroy = function() {
      if (pb.cel) {
        pb.cel.removeEventListener('click', pb.onclick);
        pb.cel.removeEventListener('mousemove', pb.onmousemove, false);
        pb.cel.width = 0;
        pb.cel.height = 0;
        delete pb.cel;
      }
      delete pb.ctx;
    }
  } /* progressbar */

  function removeEventListenerAfterFiring(cb, useCapture) {
    return function listener(event) {
      event.target.removeEventListener(event.type, listener, useCapture);
      cb();
    };
  }

  function Player() {
    let player = this;
    //player.ms;
    //sb_v;
    //var sb_a;
    //var el;
    player.mh = {};
    player.v = {ready:false, min:0, max:0, fetch_done: true};
    player.vh = {};
    player.a = {ready:false, min:0, max:0, fetch_done: true};
    player.ah = {};
    player.meta = {fetch_done: true};
    player.metah = {};
    player.idx2ms = {};
    player.prev_at = 0;
    player.video_idx = 0;
    player.audio_idx = 0;
    player.meta_idx = 0;
    player.min_buf = 1000;
    player.min_buf_cnt = 0;
    delete player.video_max;
    delete player.audio_max;
    delete player.meta_max;
    delete player.is_done;

    player.init = function(opt) {
      if (!opt || !opt.url) {
        console.warn("player error: no url");
        return;
      }
      if (!opt.vel) {
        console.warn("player error: no video element");
        return;
      }
      console.log("init",opt.url,opt.dur);
      if (!opt.url || opt.url.indexOf("http") != 0) {
        return;
      }
      player.ms = new MediaSource();
      player.el = opt.vel;
      player.el.style="display:block;margin:auto;max-width:100%;max-height:calc(98vh - 60px);";
      if (!player.ms.isJSMSE) {
        player.el.src = window.URL.createObjectURL(player.ms);
      } else {
        player.ms.setVideoEl(player.el);
      }
      if (player.ms.readyState == "open") {
        player.on_open();
      } else {
        player.ms.addEventListener
        ('sourceopen',
         removeEventListenerAfterFiring(player.on_open, false), false);
      }

      player.el.onerror = function() {
        if (!player.el || !player.el.error) { return; }
        console.warn("video error:"+player.el.error.code+
                     " "+player.el.error.message);
      }
      player.el.muted = true;
      player.url_base = opt.url;
      player.status_cb = opt.cb;
      player.subtitles = {
        has: false,
        show: false,
      };

      player.pb = new progressbar(player);
      player.pb.setcanvas(opt.pel);
      if (opt.dur) {
        player.pb.max = opt.dur;
        player.pb.at = 0;
        player.pb.down = 0;
        player.pb.update();
      }
      player.pb.sethov(opt.hov_cb);
      player.pb.setseek(function(at,d_at) {
        let min = Math.max(player.a.min,player.v.min);
        let max = Math.min(player.pb.max,player.v.max);
        if (player.is_audio_only) {
          min = player.a.min;
          max = Math.min(player.pb.max,player.a.max);
        }
        //console.log("seek",min,max,Math.trunc(at));
        if (d_at < 5 && at < player.el.currentTime) {
          // restart idx @0
          player.restart(0);
        } else if (at <= min || at >= max) {
          player.stop();
          player.pb.base = at;
          player.pb.down = at;
          player.find_idx(at, null, null, null, function(idx) {
            player.restart(idx);
          });
        } else {
          player.el.currentTime = at;
        }
      });
    }

    player.restart = function(idx) {
      console.log("restart",idx);
      player.stop();
      player.v = {ready:false, min:0, max:0, fetch_done: true};
      player.a = {ready:false, min:0, max:0, fetch_done: true};
      player.prev_at = 0;
      if (!player.is_audio_only) { player.video_idx = idx; }
      player.audio_idx = idx;
      player.min_buf = 1000;
      player.min_buf_cnt = 0;
      delete player.fetching_man;
      player.ms = new MediaSource();
      if (!player.ms.isJSMSE) {
        player.el.src = window.URL.createObjectURL(player.ms);
      } else {
        player.ms.setVideoEl(player.el);
      }
      if (player.ms.readyState == "open") {
        player.on_open();
      } else {
        player.ms.addEventListener
        ('sourceopen',
         removeEventListenerAfterFiring(player.on_open, false), false);
      }
      if (player.pb.mode == "seek") {
        player.el.play();
      }
    }
    
    player.stop = function() {
      //console.log("stopping");
      if (player.el) {
        player.el.pause();
      }
      if (player.ms && player.ms.readyState == "open") {
        try {
          if (player.ms.isJSMSE) {
            /* Clear canvas so that close() does not remove it */
            player.ms.clrVideoEl();
          }
          player.ms.endOfStream();
        } catch (e) {
          console.warn("Error while stopping "+e,e);
        }
      }
      if (player.v && player.v.sb) {
        player.v.sb.removeEventListener('updateend', player.v_updateend);
      }
      if (player.a && player.a.sb) {
        player.a.sb.removeEventListener('updateend', player.a_updateend);
      }
      if (player.ms) {
        player.ms.removeEventListener('sourceopen', player.on_open, false);
      }
      player.ms = null;
      if (player.el) {
        delete player.el.src;
      }
      if (player.tid) {
        clearTimeout(player.tid);
        delete player.tid;
      }
      if (player.subtitles) {
        player.subtitles.has = false;
        player.subtitles.show = false;
      }
      if (player.script_tid) {
        clearTimeout(player.script_tid);
        delete player.script_tid;
      }
      player.http_cancel(player.mh);
      player.http_cancel(player.vh);
      player.http_cancel(player.ah);
      player.http_cancel(player.metah);
    }

    player.destroy = function() {
      player.stop();
      if (player.pb) {
        player.pb.destroy();
      }
      if (player.el) {
        player.el.style="display:none";
        delete player.el;
      }
    }

    player.import_meta = function(j) {
      let segs = [];
      let prv_cnt = 0;
      let seg_name = "";
      player.metadb = player.metadb || [];
      j.at = j.at / 1000;
      player.metadb.push(j);
      player.metadb.forEach(function(m) {
        let cnt = (m.att && m.att.c && m.att.c.length) || 0;
        if (!m.seg_start && cnt == prv_cnt) { return; }
        prv_cnt = cnt;
        if (m.seg_start) {
          seg_name = m.seg_name;
        }
        segs.push({
          at:m.at,
          start: m.seg_start,
          name: seg_name,
          cnt: cnt,
        });
      });
      //console.log(JSON.stringify(segs));
      player.pb.set_segs(segs);
      player.pb.update();
    }

    player.check_status = function() {
      if (!player.ms) { return; }
      if ((player.is_audio_only || player.v.ready) &&
          player.a.ready) {
        if (!player.is_audio_only &&
            player.v.min >= player.a.min &&
            player.el.currentTime < player.v.min) {
          player.el.currentTime = player.v.min;
          console.log("moving ahead to v_min",player.v.min);
        } else if (player.el.currentTime < player.a.min) {
          player.el.currentTime = player.a.min;
          console.log("moving ahead to a_min",player.a.min);
        }
        //let start = Math.max(player.v.min,player.a.min);
        //let end = Math.min(player.v.max,player.a.max);
        //player.v.setting_dur = true;
        //player.a.setting_dur = true;
        //player.ms.duration = end+20;
      } else {
        //console.log("waiting on v/a",player.v.ready,player.a.ready);
      }
    }

    player.fetch_done = function(vdone,adone) {
      if (!player.ms) { return; }
      if (vdone) {
        player.v.fetch_done = true;
      }
      if (adone) {
        player.a.fetch_done = true;
      }
      if (player.v.fetch_done && player.a.fetch_done) {
        let at = player.el.currentTime;
        if (player.a.sb._removing ||
            (player.v.sb && player.v.sb._removing)) {
          console.log("wait for remove");
        } else if ((player.v.sb && (player.v.max - at) < 15) ||
                   ((player.a.max - at) < 15)) {
          player.load_next_chunk();
        } else {
          if (player.v.sb && (at - player.v.min) > 35) {
            player.v.sb._removing = true;
            player.v.sb.remove(player.v.min,at-20);
          }
          if ((at - player.a.min) > 35) {
            player.a.sb._removing = true;
            player.a.sb.remove(player.a.min,at-20);
          }
        }
      }

      if (!player.el.paused) {
        let at = player.el.currentTime;
        let tm;
        if (player.v.sb) {
          tm = player.v.sb.buffered;
        } else {
          tm = player.a.sb.buffered;
        }
        if (tm.length > 0 && at == player.prev_at) {
          //console.log("no-progress",tm.length,at,player.prev_at);
          for (var i = 0; i < tm.length; i += 1) {
            if (i < tm.length-1 &&
                at >= tm.start(i) && at <= tm.start(i+1)) {
              console.log("vgap",tm.end(i),tm.start(i+1));
              player.el.currentTime = tm.start(i+1);
            }
          }
        }
        player.prev_at = at;
      }

      if (player.status_cb) {
        let rv = {};
        if (player.el) {
          rv.paused = player.el.paused;
          rv.at = player.el.currentTime;
        }
        rv.max = player.pb.max;
        rv.is_live = player.is_live;
        rv.is_done = player.is_done;
        rv.is_audio_only = player.is_audio_only;
        if (player.metadb) {
          rv.seg_name = "";
          for (let i=0; i<player.metadb.length; ++i) {
            let m = player.metadb[i];
            if (i == 0 && rv.at < m.at) {
              /* First segment is after current elapsed */
              break;
            }
            if (m.seg_start) {
              rv.seg_name = m.seg_name;
            }
            if (rv.at >= m.at &&
                (i == (player.metadb.length-1) ||
                 rv.at < player.metadb[i+1].at)) {
              if (m.att && m.att.c) {
                rv.people = m.att.c;
              }
              break;
            }
          }
        }
        rv.at = player.pb.vidtm2disp(rv.at);
        rv.max = player.pb.vidtm2disp(rv.max);
        rv.pbmode = player.pb.mode;
        rv.subtitles = player.subtitles;
        rv.can_clip = false;
        rv.has_clip = false;
        rv.clip_cnt = 0;
        if (!player.pb.prange && player.video_max && player.audio_max) {
          /* Video does NOT have to be "done". However, it does need
           *   to be one that has a play.jman manifest. 
           *   If !done then clearly it will never have a range because
           *      original recordings don't.
           */
          rv.can_clip = true;
          if (player.pb.clips && player.pb.clips.length) {
            rv.has_clip = true;
            rv.clip_cnt = player.pb.clips.length;
          }
        }
        player.status_cb(rv);
      }
      if (player.pb) {
        player.pb.base = Math.max(player.a.min,player.v.min);
        let max = player.v.max;
        if (player.is_audio_only) {
          max = player.a.max;
        }
        player.pb.down = max;
        if (player.el) {
          player.pb.at = player.el.currentTime;
          //$("#arc_elp").html(formatelp(player.pb.at));
        }
        player.pb.max = Math.max(player.pb.max,max);
        //console.log("PB:"+player.pb.base+","+player.pb.at+","+player.pb.down);
        player.pb.update();
      }

      if (player.tid) {
        clearTimeout(player.tid);
        delete player.tid;
      }
      player.tid = setTimeout(player.fetch_done, 250);
    }

    player.http_cancel = function(av) {
      if (av.http) {
        av.http.abort();
      }
      if (av.rtid) {
        clearTimeout(av.rtid);
        delete av.rtid;
      }
    }

    player.http_json = function(av, url, cb_done) {
      if (!url) {
        /* Skip fetch */
        cb_done();
        return;
      }
      let http = new XMLHttpRequest();
      av.http = http;
      http.open("GET", url);
      http.withCredentials = false;
      http.onload = function() {
        delete av.http;
        let j;
        if (http.response) {
          j = to_json(http.response);
        }
        cb_done(http.status, j);
      };
      http.onerror = function() {
        delete av.http;
      };
      http.send();
    }
    
    player.http_retry = function(av, url, cb_done, cb_retry, cnt) {
      player.http_cancel(av);
      let http = new XMLHttpRequest();
      //console.log("fetch:"+url);
      av.http = http;
      http.open("GET", url);
      http.withCredentials = false;
      http.onload = function() {
        delete av.http;
        if (http.status >= 200 && http.status <= 299) {
          let data = new Uint8Array(http.response);
          cb_done(data);
        } else {
          //console.log("http bad status",http.status,cnt);
          cnt = (cnt || 0)+1;
          if (cb_retry(cnt)) {
            av.rtid = setTimeout(function() {
              delete av.rtid;
              //console.log("retry",cnt,JSON.stringify(av.http));
              player.http_retry(av, url, cb_done, cb_retry, cnt);
            }, 1000);
          }
        }
      };
      http.onerror = function() {
        delete av.http;
        console.warn("http error",cnt);
      };
      http.responseType = "arraybuffer";
      http.send();
    }

    player.fmp4_hdr = function(b,off) {      
      let z = ((b[off+0] << 24) |
               (b[off+1] << 16) |
               (b[off+2] << 8) |
               (b[off+3]));
      let c = (String.fromCharCode(b[off+4]) +
               String.fromCharCode(b[off+5]) +
               String.fromCharCode(b[off+6]) +
               String.fromCharCode(b[off+7]));
      return {z: z, c: c};
    }

    player.fmp4_extract = function(data,off,max,root,child) {
      child.nodes = {};
      while (off < (max-8)) {
        let hdr = player.fmp4_hdr(data,off);
        let soff = off;
        //console.log("fmp4",hdr.c,hdr.z);
        if (!hdr.z) {
          return;
        }
        child.nodes[hdr.c] = hdr;
        off += hdr.z;

        if (hdr.c == "moof") {
          player.fmp4_extract(data,soff+8,soff+hdr.z,root,hdr);
        } else if (hdr.c == "traf") {
          player.fmp4_extract(data,soff+8,soff+hdr.z,root,hdr);
        } else if (hdr.c == "tfdt") {
          let version = data[soff+8];
          let dtime = ((data[soff+8+4] << 24) |
                       (data[soff+8+5] << 16) |
                       (data[soff+8+6] << 8) |
                       (data[soff+8+7])) / 90000;
          hdr.media_decode_time = dtime;
          if (!root.media_decode_time) {
            root.media_decode_time = dtime;
          }
          //console.log("mdt at ",soff);
        }
      }
    }

    player.prom_lookup_idx = function(h,idx) {
      const lookup = function(resolve, reject) {
        h.http && h.http.abort();
        h.http = new XMLHttpRequest();
        h.http.open("GET", player.url_base+"/a/"+idx+".m4s");
        h.http.withCredentials = false;
        /* m4s headers typically in 750 range */
        h.http.setRequestHeader("Range","bytes=0-1000");
        h.http.onload = function() {
          if (h.http.status >= 200 && h.http.status <= 299) {
            let data = new Uint8Array(h.http.response);
            let root = {};
            delete h.http;
            player.fmp4_extract(data,0,data.length,root,root);
            if (root.media_decode_time) {
              resolve(root.media_decode_time);
              return;
            }
          }
          delete h.http;
          //reject("Unable to get decode time for "+idx);
          console.warn("Unable to fetch "+idx);
          resolve(-1);
        }
        h.http.onerror = function() {
          delete h.http;
          //reject("Unable to get decode time for "+idx);
          console.warn("Unable to fetch "+idx);
          resolve(-1);
        }
        h.http.responseType = "arraybuffer";
        h.http.send();
      }
      return new Promise(lookup);
    }

    player.snap_to = function(tm,bias_late) {
      let prev_ctm = player.idx2ms[0];
      for (let i=1; i<player.audio_max; ++i) {
        let ctm = player.idx2ms[i];
        if (tm == prev_ctm) {
          return [prev_ctm, i-1];
        } else if (tm == ctm) {
          return [ctm, i];
        } else if (tm > prev_ctm && tm < ctm) {
          if (!bias_late) {
            return [prev_ctm, i-1];
          } else {
            return [ctm, i];
          }
        }
        prev_ctm = ctm;
      }
      return [prev_ctm, i-1];
    }

    player.finalize_clips = function() {
      if (!player.pb || !player.pb.clips || !player.pb.clips.length) {
        return;
      }
      player.pb.clips.forEach(function(clip) {
        [clip.start, clip.start_i] = player.snap_to(clip.start);
        [clip.end, clip.end_i] = player.snap_to(clip.end,true);
      });
      player.restart(player.pb.clips[0].start_i);
    }

    player.lookup_all = async function(cb) {
      let h = [{},{},{},{}];
      for (let i=0; i<player.audio_max; ) {
        if (!player.idx2ms[i]) {
          if (i > player.audio_max-4) {
            try {
              let tm = await player.prom_lookup_idx(h[0],i);
              player.idx2ms[i] = tm;
              i += 1;
            } catch(e) {
              console.log("error",e);
              cb && cb(true);
              return;
            }
          } else {
            let p1 = player.prom_lookup_idx(h[0],i+0);
            let p2 = player.prom_lookup_idx(h[1],i+1);
            let p3 = player.prom_lookup_idx(h[2],i+2);
            let p4 = player.prom_lookup_idx(h[3],i+3);
            try {
              let rv = await Promise.all([p1,p2,p3,p4]);
              //console.log(rv);
              player.idx2ms[i+0] = rv[0];
              player.idx2ms[i+1] = rv[1];
              player.idx2ms[i+2] = rv[2];
              player.idx2ms[i+3] = rv[3];
              i += 4;
            } catch(e) {
              console.log("error",e);
              cb && cb(true);
              return;
            }
          }
        } else {
          i += 1;
        }
        cb && cb(false,(i+1)/player.audio_max);
        if (!player.pb || player.pb.mode == "seek") {
          break;
        }
      }
      return;
    }

    player.lookup_idx = function(idx, cb) {
      if (player.idx2ms[idx]) {
        cb(player.idx2ms[idx]);
        return;
      }
      if (player.audio_max && idx > player.audio_max) {
        cb("dne");
        return false;
      }

      player.http_retry(player.vh, player.url_base+"/a/"+idx+".m4s", function(data) {
        let root = {};
        player.fmp4_extract(data,0,data.length,root,root);
        if (root.media_decode_time) {
          player.idx2ms[idx] = root.media_decode_time;
          cb(root.media_decode_time);
        } else {
          console.warn("Unable to get decode time for "+idx);
          cb(-1);
        }
      }, function() {
        cb("dne");
        return false;
      });
    }

    player.find_idx = function(tgt, lo, cur, hi, cb) {
      if (!cur) { tgt=Math.trunc(tgt); lo = 0; cur = 128; }
      //console.log("find_idx:",tgt,lo,cur,hi);
      if (cur <= 2 || cur <= lo+1 || cur == hi-1) {
        //console.log("find_idx: done",cur);
        cb(cur);
        return;
      }

      player.lookup_idx(cur, function(ms) {
        if (ms < 0) {
          /* Error occurred getting decode time */
          cb(lo);
          return;
        }

        if (ms == "dne" || tgt <= ms) {
          player.find_idx(tgt, lo, Math.trunc((cur+lo)/2), cur, cb);
        } else {
          if (!hi) {
            player.find_idx(tgt, cur, cur+128, null, cb);
          } else {
            player.find_idx(tgt, cur, Math.trunc((cur+hi)/2), hi, cb);
          }
        }
      });
    }

    player.find_end = function(lo, cur, hi, cb) {
      if (!cur) { lo = 0; cur = 256; }
      //console.log("find_end:",lo,cur,hi);
      if (cur <= 2 || cur <= lo+1) {
        //console.log("find_end: done",lo);
        cb(lo);
        return;
      }

      player.lookup_idx(cur, function(ms) {
        //console.log("find_end: "+cur+" => "+ms);
        if (ms == "dne") {
          player.find_end(lo, Math.trunc((cur+lo)/2), cur, cb);
        } else {
          if (!hi) {
            player.find_end(cur, cur+256, null, cb);
          } else {
            player.find_end(cur, Math.trunc((cur+hi)/2), hi, cb);
          }
        }
      });
    }

    player.update_manifest = function(cb) {
      let url = player.url_base+"/play.jman";
      let now = Date.now();
      if (player.fetching_man) {
        /* Previous fetch still ongoing */
        cb();
        return;
      }
      if (player.video_max && player.audio_max && player.is_done) {
        /* Don't bother to fetch manifest any longer */
        url = "";
      }
      player.fetching_man = true;
      player.http_json(player.mh, url, function(status,j) {
        player.fetching_man = false;
        if (status >= 400) {
          /* No man exists. Code will assume pre-manifest style */
        } else if (j) {
          if (player.video_max != j.vmax ||
              player.audio_max != j.amax) {
            player.last_update = now;
          }
          player.video_max = j.vmax;
          player.audio_max = j.amax;
          player.meta_max = j.mmax;
          player.is_done = player.is_done || j.done;
          if (j.done && j.range) {
            //{ r:[[20,56]] }
            player.pb.set_prange(j.range);
          }
          if ((!player.is_audio_only && (now - player.last_update) > 10000) ||
              (player.is_audio_only && (now - player.last_update) > 20000)
             ) {
            /* Manifest exists and hasn't updated in 10 sec */
            player.is_done = true;
          }
          if (player.is_done) {
            if (vx && vx.debug) { console.log("Done."); }
          }
          if ((player.is_done || player.audio_max > 1) &&
              (player.video_max === -1) &&
              (player.v.sb)) {
            player.ms.removeSourceBuffer(player.v.sb);
            delete player.v.sb;
            player.is_audio_only = true;
          }
          player.load_meta();
          //console.log("max "+player.video_max,(now - player.last_update));
        }
        cb();
      });
    }

    player.to_next_idx = function(idx) {
      if (!player.pb || !player.pb.clips || !player.pb.clips.length ||
          player.pb.mode != "seek") {
        return idx+1;
      }
      if (idx < player.pb.clips[0].start_i) {
        return player.pb.clips[0].start_i;
      }
      for (let c=0; c<player.pb.clips.length; ++c) {
        let clip = player.pb.clips[c];
        let nclip = player.pb.clips[c+1];
        /* Clip end_i is the chunk index immediately AFTER the end.
           It should not be played. */
        if (idx >= clip.start_i && idx < (clip.end_i-1)) {
          /* Within this clip */
          return idx+1;
        } else if (idx >= (clip.end_i-1)) {
          if (nclip && idx >= nclip.start_i) {
            /* Check against next */
            continue;
          } else if (nclip && idx < nclip.start_i) {
            /* Between current and next */
            //console.log(`jump fetch ${idx} to ${nclip.start_i}`);
            return nclip.start_i;
          } else {
            /* Off end; stop fetch */
            return Math.max(player.video_max,player.audio_max);
          }
        }
      }
    }

    player.load_next_chunk = function() {
      player.update_manifest(function() {
        if (player.v.fetch_done && (/*OLD*/!player.video_max ||
                                    player.video_idx <= player.video_max)) {
          if (player.v.sb) {
            player.v.fetch_done = false;
            player.http_retry(player.vh, player.url_base+"/v/"+player.video_idx+".m4s", function(data) {
              player.video_idx = player.to_next_idx(player.video_idx);
              player.data_ready_v(data);
            }, function(cnt) {
              if (cnt > 5) {
                player.v.fetch_done = true;
                player.video_idx = player.to_next_idx(player.video_idx);
                return false;
              }
              return true;
            });
          }
        }

        if (player.a.fetch_done && (/*OLD*/!player.audio_max ||
                                    player.audio_idx <= player.audio_max)) {
          if (player.a.sb) {
            player.a.fetch_done = false;
            player.http_retry(player.ah, player.url_base+"/a/"+player.audio_idx+".m4s", function(data) {
              player.audio_idx = player.to_next_idx(player.audio_idx);
              player.data_ready_a(data);
            }, function(cnt) {
              if (cnt > 5) {
                player.a.fetch_done = true;
                player.audio_idx = player.to_next_idx(player.audio_idx);
                return false;
              }
              return true;
            });
          }
        }
      }); // Manifest
    }

    player.load_meta = function() {
      if (!player.meta.fetch_done) {
        return;
      }
      if (player.meta_max === undefined) {
        console.log("no meta");
        return;
      }
      if (player.meta_idx > player.meta_max) {
        console.log("no new meta",player.meta_idx,player.meta_max);
        return;
      }
      player.meta.fetch_done = false;
      player.http_json(player.metah, player.url_base+"/m/"+player.meta_idx+".json", function(status,j) {
        player.meta.fetch_done = true;
        if (status >= 200 && status < 300) {
          player.meta_idx++;
          //console.log("fetched meta",j);
          player.import_meta(j);
          setTimeout(player.load_meta, 100);
        }
      });
    }

    player.buf_min_max = function(sb) {
      if (!sb) { return []; }
      let tm = sb.buffered;
      if (!tm || !tm.length) { return []; }
      let min = tm.start(0);
      let max = tm.end(tm.length-1);
      //console.log("minmax",min,max);
      return [min, max];
    }

    player.v_updateend = function(x) {
      if (player.v.sb._appending) {
        player.v.sb._appending = false;
        let tm = player.v.sb.buffered;
        //console.log("updateendv",tm.length,player.el.currentTime,tm.length);
        if (tm.length > 0) {
          player.v.ready = true;
          [player.v.min, player.v.max] = player.buf_min_max(player.v.sb);
          player.check_status();
        }
        player.fetch_done(true,false);
      } else if (player.v.sb._removing) {
        player.v.sb._removing = false;
      } else if (player.v.setting_dur) {
        player.v.setting_dur = false;
      } else {
        console.warn("unknown updateendv");
      }
    }

    player.a_updateend = function() {
      if (player.a.sb._appending) {
        player.a.sb._appending = false;
        let tm = player.a.sb.buffered;
        //console.log("updateenda",tm.length,player.el.currentTime);
        if (tm.length > 0) {
          player.a.ready = true;
          [player.a.min, player.a.max] = player.buf_min_max(player.a.sb);
          player.check_status();
        }
        player.fetch_done(false,true);
      } else if (player.a.sb._removing) {
        player.a.sb._removing = false;
      } else if (player.a.setting_dur) {
        player.a.setting_dur = false;
      } else {
        console.warn("unknown updateenda");
      }
    }

    player.on_open = function() {
      if (!player.ms) { return; }
      if (!player.is_audio_only) {
        //console.log("add video sourcebuffer");
        player.v.sb =
          player.ms.addSourceBuffer("video/mp4; codecs=\"avc1.42c00d\"");
        player.v.sb.addEventListener("updateend", player.v_updateend);
        player.v.sb.setBuffered && player.v.sb.setBuffered(function() {
          /* Wait until JSMSE decoder is downloaded and ready */
          player.load_next_chunk();
          player.load_meta();
          player.load_subtitle();
        });
      }

      if (true) {
        //console.log("add audio sourcebuffer");
        player.a.sb =
          player.ms.addSourceBuffer("audio/mp4; codecs=\"mp4a.40.2\"");
        player.a.sb.addEventListener("updateend", player.a_updateend);
      }
      if (!player.ms.isJSMSE || player.is_audio_only) {
        player.load_next_chunk();
        player.load_meta();
        player.load_subtitle();
      }
    }

    player.data_ready_v = function(data) {
      //console.log("data_ready_v",data.byteLength);
      let min,max;
      [min, max] = player.buf_min_max(player.v.sb);
      if (max) {
        let rembuf = (max - player.el.currentTime);
        if (++player.min_buf_cnt >= 5) {
          //console.log("v lowest minbuf "+player.min_buf);
          if (player.is_live && player.min_buf > 1.9) {
            let adj = 0.3;
            if (player.min_buf > 3) {
              adj = player.min_buf - 2.5;
            }
            //console.log("v move ahead "+adj);
            player.el.currentTime += adj;
          }
          player.min_buf = 1000;
          player.min_buf_cnt = 0;
        }
        player.min_buf = Math.min(player.min_buf, rembuf);
      }
      player.v.sb._appending = true;
      player.v.sb.appendBuffer(data);
    }

    player.data_ready_a = function(data) {
      //console.log("data_ready_a",data.byteLength);
      player.a.sb._appending = true;
      player.a.sb.appendBuffer(data);
    }

    player.play = function(ev) {
      if (!player.el) { return; }
      if (ev && ev.isTrusted && player.ms && !player.ms.isJSMSE) {
        player.el.setAttribute("canplay",true);
      }
      player.el.play();
    }

    player.pause = function() {
      if (!player.el) { return; }
      player.el.pause();
    }

    player.pbmode = function(mode,cb) {
      if (!player.pb) { return; }
      if (player.pb.prange) { return; }
      if (mode == "seek") {
        player.pb.mode = "seek";
        player.finalize_clips();
      } else if (mode == "clip_select") {
        player.el.pause();
        player.pb.mode = "clip_select";
        player.lookup_all(cb);
      }
    }

    player.clear_clips = function() {
      if (!player.pb) { return; }
      if (player.pb.prange) { return; }
      player.pb.clips = [];
      delete player.pb.clip;
    }

    player.get_clip_spec = function() {
      player.el.pause();
      if (!player.pb) { return; }
      if (player.pb.mode != 'seek') { return; }
      if (!player.pb.clips) { return; }
      let spec = {};
      spec.blocks = [];
      player.pb.clips.forEach(function(clip) {
        let blk = {};
        blk.tmstart = Math.trunc(1000*clip.start);
        blk.tmend = Math.trunc(1000*clip.end);
        blk.vstart = blk.astart = clip.start_i;
        /* The API will copy chunks up to and including the
           vend block. Decrement. */
        blk.vend = blk.aend = clip.end_i-1;
        spec.blocks.push(blk);
      });
      return spec;
    }

    player.mute = function(ev,val) {
      if (!player.el) { return; }
      if (val) {
        player.el.muted = true;
      } else {
        player.el.muted = false;
        if (ev && ev.isTrusted) {
          player.el.setAttribute("canunmute",true);
        }
      }
    }

    player.set_live = function(v) {
      if (!player.el || !player.ms) { return; }
      if (v) {
        player.stop();
        player.is_live = true;
        /* Get latest manifest and then go to the end */
        player.update_manifest(function() {
          if (player.audio_max) {
            player.restart(player.audio_max - 2);
          } else {
            player.find_end(null, null, null, function(idx) {
              player.restart(idx);
            });
          }
        });
      } else {
        player.is_live = false;
      }
    }

    player.toggle_subtitles = function() {
      player.subtitles.show = !player.subtitles.show;
      if (!player.subtitles.show) {
        let sub_el = document.getElementById("_arcsub");
        if (sub_el) {
          sub_el.innerHTML = "";
        }
      }
      return player.subtitles.show;
    }

    player.load_subtitle = async function() {
      let rsp = await fetch(player.url_base+"/tscript.json");
      if (!rsp.ok) {
        console.log("Failed to load transcript");
        player.subtitles.has = false;
        return;
      }
      let sub = await rsp.json();
      if (!sub || !sub.lines) {
        console.log("Transcript is empty");
        player.subtitles.has = false;
        return;
      }
      console.log("Loaded transcript",sub.lines.length);
      player.subtitles.has = true;

      let prv = 0;
      let sub_el = document.getElementById("_arcsub");
      if (sub_el) {
        sub_el.remove();
      }
      sub_el = document.createElement("div");
      sub_el.id = "_arcsub";
      sub_el.classList.add("subtitle_box");
      player.el.parentNode.append(sub_el);

      clearTimeout(player.script_tid);
      player.script_tid = setInterval(function() {
        if (!player.el) { return; }
        if (!player.subtitles.show) { return; }
        let at = player.el.currentTime;
        let paused = player.el.paused;
        let h = "";
        if (at == prv) { return; }
        prv = at;
        sub.lines.forEach(function(line) {
          let spknum = line.who.split("_")[1] || "0";
          let who = "S-"+spknum+":";
          if (at >= (line.st-0.5) && at < (line.et+3)) {
            h += '<div style="width:100%"><div class="subtitle_line"><span class="subtitle_name" spk="'+spknum+'">'+who+'</span><span class="subtitle_txt">'+line.txt+"</span></div></div>";
            if (line.showing) { return; }
            line.showing = true;
            //console.log("show",line.txt,line.st,line.et);
          } else {
            if (!line.showing) { return; }
            //console.log("clear",line.txt);
            delete line.showing;
          }
        });
        sub_el.innerHTML = h;
      }, 100);
    }
  }
  
  return Player;
}
